import React from 'react';

const PlaneIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 21 21'
      {...props}
    >
      <path
        className='subheader__container-link-icon'
        d='M20.407.593a2.026 2.026 0 00-2.894.03l-4.3 4.483L2.712 1.631l-2.2 2.2 8.747 5.392-4.428 4.614-2.84-.466L0 15.363l4.175 1.462L5.637 21l1.992-1.992-.466-2.84 4.614-4.428 5.388 8.751 2.2-2.2-3.474-10.5 4.483-4.3a2.026 2.026 0 00.033-2.898z'
        fill='#fff'
      />
    </svg>
  );
};
export default PlaneIcon;
